import React, { useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import { deleteCandidateQuote, fetchCandidateQuotes, postCandidateQuote } from '../../api/candidate';
import useFetch from '../../hooks/useFetch';
import List from '../common/list';
import Section from '../common/section';
import Quote from '../quote';
import { Grid } from '@material-ui/core';
import QuoteForm from '../../components/forms/quote';
import useDebounce from '../../hooks/useDebounce';
import useNotification from '../../hooks/useNotification';

const Quotes = ({edit,reloadCandidateUpdatedAtData}) => {
  const { hash } = useParams();
  const [quoteChanges, setQuoteChanges] = useState(0);
  const [quoteDisabled, setQuoteDisabled] = useState(false);
  const { result: quotes } = useFetch(fetchCandidateQuotes, hash, [hash, quoteChanges]);
  const notifications = useNotification();
  /*
  const isEnabled = useRouteMatch({
    path: '/candidates/:hash/edit',
    exact: true,
  });
  */

  const handleAddQuote = useDebounce(({ author, position, company, comment }) => {
    setQuoteDisabled(true);
    postCandidateQuote(hash, { immediately: true, author, position, company, comment })
    .then((res) => {
      if (res.success) {
        reloadCandidateUpdatedAtData()
        setQuoteChanges((prev) => prev + 1);
        notifications.success({message: 'Quote was successfully added'});
      } else {
        notifications.error(res.error);
      }                     
    })
    .finally(() => {
      setQuoteDisabled(false);
    })
  }, 1000);

  const handleDeleteQuote = useDebounce((quote) => {
    deleteCandidateQuote(hash, { immediately: true, quote })
    .then((res) => {
      if (res.success) {
        reloadCandidateUpdatedAtData()
        setQuoteChanges((prev) => prev + 1);
        notifications.success({message: 'Quote was successfully deleted'});
      } else {
        notifications.error(res.error);
      }
    })
  }, 1000);
 

  if (!edit && (!quotes || !Array.isArray(quotes) || !quotes.length)) return null;

  return (
    <Section title="What clients say" /*disabled={!isEnabled}*/>
      {quotes?.length > 0 && (<List
        list={quotes}
        item={(quote) => 
          <Quote 
            reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData} 
            key={quote.hash} 
            edit={edit} 
            {...quote} 
            onDelete={handleDeleteQuote} 
          />
        }
        />
      )}
      {edit &&
        <Grid item xs={12} md={12}>
          <QuoteForm disabled={quoteDisabled} onSubmit={handleAddQuote} />
        </Grid>
      }
    </Section>
  );
};

export default Quotes;
